import { render, staticRenderFns } from "./PasswordEdit.vue?vue&type=template&id=72c2df6c&scoped=true&"
import script from "./PasswordEdit.vue?vue&type=script&lang=js&"
export * from "./PasswordEdit.vue?vue&type=script&lang=js&"
import style0 from "./PasswordEdit.vue?vue&type=style&index=0&id=72c2df6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2df6c",
  null
  
)

export default component.exports